import React, { useEffect, useState, useCallback } from "react";
import NavHeightAdjust from "../../../components/navbar/NavHeightAdjust";
import API_BASE_URL from "../../../Constants";
import { useAuth } from "../../../contexts/AuthContext";
import PdfModal from "./PdfModal";

const notificationLetterListFields = [
  // { key: "inspectionDocumentId", label: "Document ID" },
  { key: "inspectionId", label: "Inspection ID" },
  { key: "testType", label: "Test Type" },
  { key: "buildingReference", label: "Building Site" },
  { key: "documentType", label: "Document Type" },
  { key: "approvalDate", label: "Approval Date" },
  { key: "actions", label: "Actions" },
];

const NotificationLetterList = () => {
  // const [notificationLetters, setNotificationLetters] = useState([]);
  const [filteredNotificationLetters, setFilteredNotificationLetters] =
    useState([]);
  // const [searchQuery, setSearchQuery] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPdfUrl, setSelectedPdfUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const { user } = useAuth();

  const handleViewClick = (pdfUrl) => {
    setSelectedPdfUrl(pdfUrl);
    setIsModalOpen(true);
  };

  const approveInspection = async (inspectionId) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/inspections/${inspectionId}/approve`,
        {
          method: "POST",
          credentials: "include",
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      await response.json();
      fetchNotificationLetters();
    } catch (error) {
      console.error("Error approving inspection:", error);
    }
  };

  // Fetch Proposals
  const fetchNotificationLetters = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await fetch(
        `${API_BASE_URL}/api/inspections/notification-letters/${user.userId}/customer`,
        { credentials: "include" }
      );
      if (!response.ok) throw new Error("Network response was not ok");

      const data = await response.json();
      // setNotificationLetters(data);
      setFilteredNotificationLetters(data);
    } catch (error) {
      console.error("Fetch error: ", error);

      // setNotificationLetters([]);
      setFilteredNotificationLetters([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchNotificationLetters();
  }, [fetchNotificationLetters]);

  return (
    <NavHeightAdjust>
      <div className="mx-auto pl-4 pr-4 h-screen w-full">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold">Notification Letters</h2>
        </div>

        {/* Table */}
        {!isLoading ? (
          <table className="min-w-full bg-white rounded-lg shadow-lg overflow-visible border-2 border-gray-200 relative">
            <thead className="bg-gray-200">
              <tr>
                {notificationLetterListFields.map((field) => (
                  <th
                    key={field.key}
                    style={{
                      display: "table-cell",
                      cursor: "pointer",
                    }}
                    className={`px-4 py-2 text-left font-bold text-sss-blue-sel relative `}
                  >
                    {field.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="text-gray-700">
              {filteredNotificationLetters.map((notificationLetter, index) => (
                <tr
                  key={notificationLetter.inspectionDocumentId}
                  className={`border-t ${
                    index % 2 === 0 ? "bg-gray-50" : "bg-white"
                  } hover:bg-yellow-300`}
                >
                  {notificationLetterListFields.map((field) => {
                    if (field.key === "actions") {
                      return (
                        <td key={field.key} className="px-4 py-2 table-cell">
                          <button
                            className="text-blue-600"
                            onClick={() =>
                              handleViewClick(notificationLetter.url)
                            }
                          >
                            View
                          </button>
                        </td>
                      );
                    } else if (field.key === "approvalDate") {
                      if (notificationLetter[field.key]) {
                        const date = new Date(notificationLetter[field.key]);
                        return (
                          <td key={field.key} className="px-4 py-2 table-cell">
                            {date.toLocaleDateString("en-US", {
                              year: "numeric",
                              month: "2-digit",
                              day: "2-digit",
                            })}
                          </td>
                        );
                      } else {
                        return (
                          <td key={field.key} className="px-4 py-2 table-cell">
                            <button
                              className="text-blue-600"
                              onClick={() =>
                                approveInspection(
                                  notificationLetter.inspectionId
                                )
                              }
                            >
                              Approve
                            </button>
                          </td>
                        );
                      }
                    }

                    return (
                      <td key={field.key} className="px-4 py-2 table-cell">
                        {notificationLetter[field.key] || "N/A"}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="flex justify-center items-center mt-6">
            <p>Loading...</p>
          </div>
        )}
      </div>
      <PdfModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        pdfUrl={selectedPdfUrl}
      />
    </NavHeightAdjust>
  );
};

export default NotificationLetterList;
